// node_modules
import { action, computed, observable } from 'mobx';
// modules
import LoadingStore from 'modules/Loading';
// services
import SearchService from './service';
// constants
import {
  DEFAULT_SEARCH_TABS,
  DEFAULT_SEARCH_RESULTS,
} from './constants';

class SearchStore extends SearchService {
  // observables
  @observable searchText = '';
  @observable selectedTab = 0;
  @observable isSearchAvailable = false;
  @observable isTabSelectAvaliable = true;
  @observable tabs: RenderTabs = DEFAULT_SEARCH_TABS;

  searchResults: SearchResult = observable.object(
    DEFAULT_SEARCH_RESULTS,
    {},
    { deep: false },
  );

  @action setTabSelectAvaliable = (variant: boolean) => {
    this.isTabSelectAvaliable = variant;
  };

  @action clearResult = () => {
    this.toggleSearchAvailability(false);
    LoadingStore.setLoading('SEARCH_SCRIPS', false);
    this.tabs = DEFAULT_SEARCH_TABS;

    Object.entries(this.searchResults).forEach(([key]) => {
      this.searchResults[key as keyof SearchResult] = [];
    });
  };

  @action clearSearchText = () => {
    this.searchText = '';

    this.toggleSearchAvailability(false);
    this.clearResult();
  };

  @action setSelectedTab = (tab: number) => {
    this.selectedTab = tab;
  };

  @action toggleSearchAvailability = (isAvailable?: boolean) => {
    this.isSearchAvailable = isAvailable ?? !this.isSearchAvailable;
  };

  @computed get selectedTabId() {
    return this.tabs[this.selectedTab].title;
  }

  @computed get searchData() {
    return this.searchResults[this.selectedTabId];
  }

  @computed get searchLength() {
    return this.searchData.length;
  }
}

export default new SearchStore();
